import Marquee from "react-fast-marquee";
import { Diamond } from "lucide-react";
import { SectionHeading } from "./Reveal";

const BENEFITS = [
  "Expert Financial Advisory",
  "Multiple Financing Solutions",
  "Property & Business Funding",
  "Structured Loan Solutions",
  "Dedicated Relationship Support",
];

export const TrustMarquee = () => (
  <section className="border-y border-gray-200 bg-fog py-20 md:py-24" data-testid="trust-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <SectionHeading
        overline="Why Guidance Matters"
        title="Smart Financing Starts with the Right Guidance."
        testId="trust-heading"
      />
    </div>
    <div className="mt-14 overflow-hidden" data-testid="trust-marquee">
      <Marquee speed={18} gradient={false} pauseOnHover>
        {[...BENEFITS, ...BENEFITS].map((b, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="whitespace-nowrap font-heading text-2xl font-semibold tracking-tight text-gray-400 md:text-3xl">{b}</span>
            <Diamond size={12} className="fill-gold text-gold" />
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);
